(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncSlideLinks = () => {
      document.querySelectorAll('slideshow-slide').forEach((slide) => {
        const imageLink = slide.querySelector('.slide__image-link[data-use-button-link]');
        if (!imageLink) return;
        const content = slide.querySelector('.group-block-content');
        const buttonLink = content?.querySelector('a.button[href], a[class*="button"][href]') || content?.querySelector('a[href]');
        if (buttonLink && buttonLink.getAttribute('href')) {
          imageLink.setAttribute('href', buttonLink.getAttribute('href'));
          const label = buttonLink.textContent.trim();
          if (label) imageLink.setAttribute('aria-label', label);
        } else {
          imageLink.removeAttribute('href');
        }
      });
    };
    syncSlideLinks();
    document.addEventListener('DOMContentLoaded', syncSlideLinks);
    document.addEventListener('shopify:section:load', syncSlideLinks);
    document.addEventListener('shopify:block:select', syncSlideLinks);
  })();
  } catch(e) { console.error(e); }
})();

})();
